import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfService = () => {
  const styles = {
    container: {
      fontFamily: "'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      backgroundColor: '#0F172A',
      color: '#CBD5E1',
      minHeight: '100vh',
      WebkitFontSmoothing: 'antialiased',
      paddingBottom: '80px',
    },
    nav: {
      position: 'sticky',
      top: 0,
      width: '100%',
      zIndex: 50,
      backgroundColor: 'rgba(15, 23, 42, 0.85)',
      backdropFilter: 'blur(12px)',
      WebkitBackdropFilter: 'blur(12px)',
      borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
    },
    navInner: {
      maxWidth: '1000px',
      margin: '0 auto',
      padding: '16px 24px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    logo: {
      fontSize: '1.35rem',
      fontWeight: '800',
      letterSpacing: '-0.03em',
      color: '#FFFFFF',
      textDecoration: 'none',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    logoAccent: {
      color: '#6366F1',
    },
    logoTag: {
      fontSize: '0.75rem',
      fontWeight: '600',
      color: '#94A3B8',
      backgroundColor: 'rgba(99, 102, 241, 0.12)',
      padding: '2px 8px',
      borderRadius: '6px',
      border: '1px solid rgba(99, 102, 241, 0.25)',
      marginLeft: '6px',
    },
    navLinks: {
      display: 'flex',
      alignItems: 'center',
      gap: '16px',
    },
    navLink: (isActive) => ({
      fontSize: '0.875rem',
      fontWeight: '500',
      color: isActive ? '#FFFFFF' : '#94A3B8',
      textDecoration: 'none',
      padding: '6px 14px',
      borderRadius: '8px',
      backgroundColor: isActive ? 'rgba(79, 70, 229, 0.2)' : 'transparent',
      border: isActive ? '1px solid rgba(99, 102, 241, 0.4)' : '1px solid transparent',
      transition: 'all 0.2s ease',
    }),
    backLink: {
      fontSize: '0.875rem',
      color: '#94A3B8',
      textDecoration: 'none',
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      padding: '6px 12px',
      borderRadius: '8px',
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      border: '1px solid rgba(255, 255, 255, 0.08)',
    },
    main: {
      maxWidth: '1000px',
      margin: '0 auto',
      padding: '56px 24px 0',
    },
    header: {
      textAlign: 'center',
      marginBottom: '48px',
    },
    badge: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '6px',
      padding: '4px 14px',
      marginBottom: '20px',
      fontSize: '0.75rem',
      fontWeight: '700',
      letterSpacing: '0.06em',
      color: '#818CF8',
      textTransform: 'uppercase',
      backgroundColor: 'rgba(129, 140, 248, 0.12)',
      borderRadius: '9999px',
      border: '1px solid rgba(129, 140, 248, 0.25)',
    },
    title: {
      fontSize: '2.75rem',
      fontWeight: '800',
      color: '#FFFFFF',
      marginBottom: '16px',
      letterSpacing: '-0.03em',
      lineHeight: '1.2',
    },
    gradientText: {
      background: 'linear-gradient(90deg, #6366F1, #A855F7)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
    },
    metaText: {
      color: '#94A3B8',
      fontSize: '0.95rem',
    },
    card: {
      backgroundColor: 'rgba(30, 41, 59, 0.6)',
      backdropFilter: 'blur(16px)',
      WebkitBackdropFilter: 'blur(16px)',
      border: '1px solid rgba(255, 255, 255, 0.08)',
      borderRadius: '24px',
      padding: '44px',
      boxShadow: '0 20px 40px -15px rgba(0, 0, 0, 0.5)',
    },
    section: {
      marginBottom: '40px',
    },
    sectionTitle: {
      fontSize: '1.4rem',
      fontWeight: '700',
      color: '#FFFFFF',
      marginBottom: '14px',
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      letterSpacing: '-0.02em',
    },
    p: {
      lineHeight: '1.75',
      marginBottom: '16px',
      color: '#CBD5E1',
      fontSize: '0.975rem',
    },
    ul: {
      listStyleType: 'disc',
      paddingLeft: '24px',
      marginBottom: '18px',
      lineHeight: '1.75',
      color: '#CBD5E1',
    },
    calloutBox: {
      padding: '24px',
      borderRadius: '16px',
      marginBottom: '24px',
      border: '1px solid',
    },
    calloutGuarantee: {
      backgroundColor: 'rgba(16, 185, 129, 0.08)',
      borderColor: 'rgba(16, 185, 129, 0.25)',
      color: '#D1FAE5',
    },
    calloutWarning: {
      backgroundColor: 'rgba(245, 158, 11, 0.08)',
      borderColor: 'rgba(245, 158, 11, 0.25)',
      color: '#FEF3C7',
    },
    calloutPaddle: {
      backgroundColor: 'rgba(99, 102, 241, 0.08)',
      borderColor: 'rgba(99, 102, 241, 0.25)',
      color: '#E0E7FF',
    },
    calloutHeading: {
      fontSize: '1.05rem',
      fontWeight: '700',
      marginBottom: '8px',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    tableWrapper: {
      overflowX: 'auto',
      marginBottom: '20px',
      borderRadius: '12px',
      border: '1px solid rgba(255, 255, 255, 0.08)',
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      textAlign: 'left',
      fontSize: '0.9rem',
    },
    th: {
      backgroundColor: 'rgba(15, 23, 42, 0.8)',
      padding: '12px 16px',
      borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
      color: '#FFFFFF',
      fontWeight: '600',
    },
    td: {
      padding: '12px 16px',
      borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
      color: '#CBD5E1',
    },
    footer: {
      textAlign: 'center',
      paddingTop: '36px',
      marginTop: '60px',
      borderTop: '1px solid rgba(255, 255, 255, 0.08)',
      fontSize: '0.875rem',
      color: '#64748B',
    },
    footerLinks: {
      display: 'flex',
      justifyContent: 'center',
      gap: '20px',
      marginTop: '12px',
    },
  };

  return (
    <div style={styles.container}>
      {/* Navigation */}
      <nav style={styles.nav}>
        <div style={styles.navInner}>
          <Link to="/" style={styles.logo}>
            <span>On<span style={styles.logoAccent}>Track</span></span>
            <span style={styles.logoTag}>FinOps & GreenOps</span>
          </Link>
          <div style={styles.navLinks}>
            <Link to="/terms" style={styles.navLink(true)}>Terms of Service</Link>
            <Link to="/privacy" style={styles.navLink(false)}>Privacy Policy</Link>
            <Link to="/" style={styles.backLink}>
              ← Back to App
            </Link>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main style={styles.main}>
        <header style={styles.header}>
          <div style={styles.badge}>Enterprise SaaS Agreement</div>
          <h1 style={styles.title}>
            Terms of <span style={styles.gradientText}>Service</span>
          </h1>
          <p style={styles.metaText}>
            Effective Date: September 10, 2026 &bull; Version 2.4 (Production B2B)
          </p>
        </header>

        <div style={styles.card}>
          {/* Section 1 */}
          <section style={styles.section}>
            <h2 style={styles.sectionTitle}>1. Agreement and Purpose</h2>
            <p style={styles.p}>
              These Terms of Service ("<strong>Agreement</strong>" or "<strong>Terms</strong>") constitute a legally binding
              contract entered into by and between <strong>OnTrack S.R.L.</strong> ("<strong>OnTrack</strong>", "<strong>we</strong>", "<strong>us</strong>", or "<strong>our</strong>")
              and the legal business entity ("<strong>Customer</strong>", "<strong>Subscriber</strong>", or "<strong>you</strong>") accessing or utilizing the
              OnTrack Cloud, FinOps, and GreenOps platform, APIs, lightweight Go telemetry agents, Helm charts, and associated services (collectively, the "<strong>Service</strong>").
            </p>
            <p style={styles.p}>
              By provisioning an account, generating an agent registration token, deploying the OnTrack Go telemetry daemon into a Kubernetes cluster, or executing a subscription agreement,
              you represent and warrant that you possess full corporate authority to bind your organization to these Terms. If you do not possess such authority, or do not agree with all terms, you must not access or deploy the Service.
            </p>
          </section>

          {/* Section 2 */}
          <section style={styles.section}>
            <h2 style={styles.sectionTitle}>2. Scope of Services</h2>
            <p style={styles.p}>
              OnTrack provides an enterprise-grade cloud cost (FinOps) and carbon emission reduction (GreenOps) intelligence platform tailored for Kubernetes infrastructure.
              The Service encompasses:
            </p>
            <ul style={styles.ul}>
              <li>
                <strong>Lightweight Telemetry Streaming:</strong> Deployment of a lightweight open-source Go agent into Customer Kubernetes clusters via Helm or OCI artifacts, streaming periodic resource consumption telemetry.
              </li>
              <li>
                <strong>Manifest & Workload Utilization Analysis:</strong> Automated calculation of resource efficiency metrics, comparing pod requests and limits against actual CPU/memory utilization curves.
              </li>
              <li>
                <strong>AI-Driven Optimization Heuristics:</strong> Deep learning and heuristic cost/carbon synthesis (powered by Google Cloud Vertex AI) delivering workload right-sizing, idle pod elimination, and node pool rightsizing recommendations.
              </li>
              <li>
                <strong>Automated Remediation Scripts:</strong> Generation of copy-paste or automated <code>kubectl patch</code> scripts, tuned Kubernetes resource manifests, and GitOps pull request templates.
              </li>
            </ul>
          </section>

          {/* Section 3: Zero-Payload Guarantee */}
          <section style={styles.section}>
            <h2 style={styles.sectionTitle}>3. Telemetry Scope & Zero-Payload Guarantee</h2>
            <p style={styles.p}>
              OnTrack is architected under strict zero-trust principles for mission-critical cloud infrastructure. The telemetry collected by the Go agent is restricted strictly to non-sensitive structural metadata.
            </p>

            <div style={{ ...styles.calloutBox, ...styles.calloutGuarantee }}>
              <div style={styles.calloutHeading}>
                <span>🔒</span> Zero-Payload & Zero-Secret Guarantee
              </div>
              <p style={{ ...styles.p, color: '#D1FAE5', marginBottom: 0 }}>
                The OnTrack Go agent and backend pipelines <strong>NEVER</strong> intercept, capture, inspect, or transmit:
                application payloads, HTTP/gRPC request or response bodies, Kubernetes Secrets, TLS private keys, environment variables,
                database rows or queries, customer source code, or internal network traffic. The agent requires minimal read-only Kubernetes RBAC permissions exclusively targeted at the Metrics API (<code>metrics.k8s.io</code>) and workload specs.
              </p>
            </div>

            <div style={styles.tableWrapper}>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th}>Telemetry Category</th>
                    <th style={styles.th}>Data Fields Collected</th>
                    <th style={styles.th}>Explicit Exclusions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={styles.td}><strong>Cluster Resources</strong></td>
                    <td style={styles.td}>CPU/Memory requests, limits, actual core/byte usage, pod counts, container status.</td>
                    <td style={styles.td}>Payload data, stdin/stdout/stderr logs, process arguments.</td>
                  </tr>
                  <tr>
                    <td style={styles.td}><strong>Infrastructure Specs</strong></td>
                    <td style={styles.td}>Node instance types (e.g., e2-standard-4), cloud provider region (e.g., us-central1), architecture.</td>
                    <td style={styles.td}>Private IP networks, host filesystem, kernel parameters.</td>
                  </tr>
                  <tr>
                    <td style={styles.td}><strong>GreenOps Metrics</strong></td>
                    <td style={styles.td}>Regional electrical grid carbon intensity factors (gCO2eq/kWh), estimated Scope 2 embodied emissions.</td>
                    <td style={styles.td}>Proprietary hardware diagnostics or physical facility data.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          {/* Section 4: Advisory Remediation Disclaimer */}
          <section style={styles.section}>
            <h2 style={styles.sectionTitle}>4. Advisory Remediation Disclaimer & Human-in-the-Loop Validation</h2>
            
            <div style={{ ...styles.calloutBox, ...styles.calloutWarning }}>
              <div style={styles.calloutHeading}>
                <span>⚠️</span> Human-in-the-Loop Requirement for Infrastructure Changes
              </div>
              <p style={{ ...styles.p, color: '#FEF3C7', marginBottom: 0 }}>
                All cost optimization suggestions, carbon reduction calculations, resource adjustments, and <code>kubectl patch</code> scripts
                generated by the Service are <strong>strictly advisory recommendations</strong>. Customer engineering personnel must independently review,
                validate, and benchmark all recommendations in non-production environments prior to applying changes to staging or production clusters.
              </p>
            </div>

            <p style={styles.p}>
              OnTrack explicitly disclaims any liability for service interruptions, pod eviction loops, out-of-memory (OOM) termination events,
              latency degradation, cluster partition, or application downtime resulting from Customer's application or execution of remediation patches,
              whether executed manually or through automated CI/CD pipeline triggers. Customer retains sole operational control over its Kubernetes infrastructure.
            </p>
          </section>

          {/* Section 5: Merchant of Record (Paddle) */}
          <section style={styles.section}>
            <h2 style={styles.sectionTitle}>5. Merchant of Record (Paddle) & Billing Terms</h2>

            <div style={{ ...styles.calloutBox, ...styles.calloutPaddle }}>
              <div style={styles.calloutHeading}>
                <span>💳</span> Billing & Subscriptions Managed by Paddle
              </div>
              <p style={{ ...styles.p, color: '#E0E7FF', marginBottom: 0 }}>
                Our order process and payment handling is conducted by our online reseller and Merchant of Record, <strong>Paddle.com Inc.</strong> and its affiliates ("<strong>Paddle</strong>").
                Paddle is the Merchant of Record for all our orders, providing customer service inquiries and handling returns, invoicing, and regional tax compliance.
              </p>
            </div>

            <p style={styles.p}>
              When purchasing a subscription tier (e.g., Developer, Team, Pro, or Enterprise), you agree to be bound by Paddle's Checkout Terms and Conditions. Specifically:
            </p>
            <ul style={styles.ul}>
              <li>
                <strong>Billing Cycles:</strong> Subscriptions are billed in advance on a recurring monthly or annual basis corresponding to the selected plan tier.
              </li>
              <li>
                <strong>Taxes & Compliance:</strong> Paddle is solely responsible for the calculation, collection, and remittance of applicable global sales tax, VAT, GST, and consumption taxes.
              </li>
              <li>
                <strong>Cancellations & Renewals:</strong> You may cancel recurring billing at any time via the OnTrack billing portal or Paddle receipt management link. Cancellation terminates auto-renewal at the end of the current paid billing cycle.
              </li>
              <li>
                <strong>Refund Policy:</strong> Disputed charges and refund requests are governed by Paddle's standard Merchant of Record refund criteria and must be submitted within 14 days of transaction settlement.
              </li>
            </ul>
          </section>

          {/* Section 6: Security and Token Confidentiality */}
          <section style={styles.section}>
            <h2 style={styles.sectionTitle}>6. Cluster Agent Security & Token Management</h2>
            <p style={styles.p}>
              Access to Customer cluster telemetry streams is authenticated via SHA-256 hashed API registration keys. Customer is responsible for:
            </p>
            <ul style={styles.ul}>
              <li>Safeguarding cluster registration tokens and treating them as confidential infrastructure secrets.</li>
              <li>Restricting Kubernetes RBAC permissions of the agent DaemonSet according to the official principle of least privilege.</li>
              <li>Promptly revoking and rotating tokens via the OnTrack dashboard in the event of suspected credential compromise.</li>
            </ul>
          </section>

          {/* Section 7: Intellectual Property */}
          <section style={styles.section}>
            <h2 style={styles.sectionTitle}>7. Intellectual Property & License Grants</h2>
            <p style={styles.p}>
              <strong>OnTrack Intellectual Property:</strong> OnTrack and its licensors retain all right, title, and interest in and to the Service, including the Go telemetry daemon, proprietary cost analysis algorithms, GreenOps calculation engines, user interfaces, documentation, and all related intellectual property rights.
            </p>
            <p style={styles.p}>
              <strong>Customer Telemetry:</strong> Customer grants OnTrack a non-exclusive, worldwide, royalty-free license to ingest, process, and aggregate non-identifiable telemetry strictly for the provision and operational optimization of the Service. Customer telemetry is never used to train public foundational AI models.
            </p>
          </section>

          {/* Section 8: Limitation of Liability */}
          <section style={styles.section}>
            <h2 style={styles.sectionTitle}>8. Limitation of Liability</h2>
            <p style={styles.p}>
              TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL EITHER PARTY BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL,
              OR PUNITIVE DAMAGES, INCLUDING WITHOUT LIMITATION LOSS OF PROFITS, DATA LOSS, BUSINESS INTERRUPTION, LOSS OF GOODWILL, OR CLUSTER DOWNTIME,
              ARISING OUT OF OR IN CONNECTION WITH THIS AGREEMENT OR THE USE OF THE SERVICE, REGARDLESS OF THE THEORY OF LIABILITY (CONTRACT, TORT, NEGLIGENCE, STRICT LIABILITY, OR OTHERWISE).
            </p>
            <p style={styles.p}>
              EACH PARTY'S AGGREGATE CUMULATIVE LIABILITY UNDER OR RELATED TO THIS AGREEMENT SHALL BE STRICTLY LIMITED TO THE TOTAL SUM OF FEES ACTUALLY PAID
              BY CUSTOMER TO ONTRACK (OR PADDLE AS MERCHANT OF RECORD) FOR THE SPECIFIC SERVICE GIVING RISE TO LIABILITY IN THE TWELVE (12) MONTHS PRECEDING THE INCIDENT.
            </p>
          </section>

          {/* Section 9: Term and Termination */}
          <section style={styles.section}>
            <h2 style={styles.sectionTitle}>9. Term, Suspension, and Mutual Termination</h2>
            <p style={styles.p}>
              <strong>Term:</strong> This Agreement begins upon your initial deployment or account registration and continues until all subscriptions expire or are terminated.
            </p>
            <p style={styles.p}>
              <strong>Mutual Termination for Cause:</strong> Either party may terminate this Agreement upon thirty (30) days written notice if the other party materially breaches any provision and fails to cure such breach within the notice window.
            </p>
            <p style={styles.p}>
              <strong>Effect of Termination:</strong> Upon termination, Customer shall uninstall the Go telemetry agent from all managed clusters. OnTrack will revoke agent authentication keys and execute automated data purge sequences in compliance with our Privacy Policy.
            </p>
          </section>

          {/* Section 10: Governing Law & Jurisdiction */}
          <section style={styles.section}>
            <h2 style={styles.sectionTitle}>10. Governing Law and Dispute Resolution</h2>
            <p style={styles.p}>
              This Agreement shall be governed by and construed in accordance with the substantive laws of the Republic of Costa Rica, without regard to its conflict of law principles.
              The parties consent to the exclusive jurisdiction of the competent commercial courts situated in San José, Costa Rica. The United Nations Convention on Contracts for the International Sale of Goods does not apply.
            </p>
          </section>

          {/* Section 11: Contact */}
          <section style={styles.section}>
            <h2 style={styles.sectionTitle}>11. Legal Inquiries & Contact</h2>
            <p style={styles.p}>
              For enterprise inquiries, legal notices, or compliance verifications, please direct correspondence to:
            </p>
            <p style={{ color: '#818CF8', fontWeight: '600', fontSize: '1rem' }}>
              legal@on-track-app.com
            </p>
            <p style={{ ...styles.p, fontSize: '0.875rem', color: '#94A3B8' }}>
              OnTrack S.R.L. &bull; Enterprise FinOps Division &bull; San José, Costa Rica
            </p>
          </section>
        </div>

        {/* Footer */}
        <footer style={styles.footer}>
          <p>&copy; 2026 OnTrack S.R.L. All rights reserved. Enterprise B2B FinOps & GreenOps Platform.</p>
          <div style={styles.footerLinks}>
            <Link to="/terms" style={{ color: '#818CF8', textDecoration: 'none' }}>Terms of Service</Link>
            <span style={{ color: '#475569' }}>&bull;</span>
            <Link to="/privacy" style={{ color: '#94A3B8', textDecoration: 'none' }}>Privacy Policy</Link>
            <span style={{ color: '#475569' }}>&bull;</span>
            <a href="mailto:legal@on-track-app.com" style={{ color: '#94A3B8', textDecoration: 'none' }}>Contact Legal</a>
          </div>
        </footer>
      </main>
    </div>
  );
};

export default TermsOfService;
